import { Localized } from "@fluent/react"
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@mui/material"
import { useCallback, useState } from "react"
import { inviteProcessTeamMember, ProjectProcessTeamMember } from "../ProjectProcessApiClient"
import { AppId, AppTextFieldHandler } from "../../../../app/appTypes"
import { useAppDispatch } from "../../../../app/hooks"
import { CancelButton } from "../../../../app/components/CancelButton"
import { SaveButton } from "../../../../app/components/SaveButton"
import { showError, showSuccess } from "../../../notifications/notificationsSlice"
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";

export interface InviteProcessTeamMemberDialogProps {
    processId: AppId
    onSave: (tm: ProjectProcessTeamMember) => void
    onCancel: () => void,
}

export const InviteProcessTeamMemberDialog = ({ processId, onSave, onCancel }: InviteProcessTeamMemberDialogProps) => {
    const dispatch = useAppDispatch()
    const [userRole, setUserRole] = useState<string>("")
    const [saving, setSaving] = useState(false);
    const [serverError, setServerError] = useState("");
    const [userEmail, setUserEmail] = useState<string>("")

    const handleUserRoleChange: AppTextFieldHandler = useCallback(e => setUserRole(e.target.value), [setUserRole])
    const handleUserEmailChange: AppTextFieldHandler = useCallback(e => setUserEmail(e.target.value), [setUserEmail])

    const handleOkClick = async () => {
        if (userEmail && userRole) {
            setSaving(true);
            try {
                const result = await dispatch(inviteProcessTeamMember({ userEmail: userEmail, processId, role: userRole }));


                if (inviteProcessTeamMember.fulfilled.match(result)) {
                    const newTeamMember = result.payload as ProjectProcessTeamMember;

                    dispatch(showSuccess("sucess"));
                    onSave(newTeamMember);
                } else {
                    let errorMsg = "error";
                    if (result.payload && result.payload.kind === "http") {
                        const problem = result.payload.problem;
                        if (problem) {
                            errorMsg = problem.title;
                        }
                    }
                    setServerError(errorMsg);
                }
            } catch (error) {
                dispatch(showError("error"));
            } finally {
                setSaving(false);
            }
        }
    };


    return <>
        <Dialog open={true} fullWidth maxWidth='sm'>
            <DialogTitle sx={{
                bgcolor: "grey.100",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                py: 1,
            }}>
                <PublicRoundedIcon color="success" />

                <Localized id="process-invite-team-member">
                    <span>Zaproś</span>
                </Localized>
            </DialogTitle>
            <DialogContent sx={{
                padding: 2,
                mt: 3
            }}>
                <TextField
                    sx={{
                        marginTop: 1,
                    }}
                    value={userEmail}
                    fullWidth
                    required={true}
                    label={<Localized id="email-address"><span>Email</span></Localized>}
                    onChange={handleUserEmailChange}
                >
                </TextField>
                <TextField
                    sx={{
                        marginTop: 1,
                    }}
                    value={userRole}
                    fullWidth
                    required={true}
                    select
                    label={<Localized id="urs-user-role"><span>Rola</span></Localized>}
                    onChange={handleUserRoleChange}
                >

                    <MenuItem value={"C"}><Localized id="project-role-collaborator"><span>Collaborator</span></Localized></MenuItem>
                    <MenuItem value={"O"}><Localized id="project-role-observer"><span>Observer</span></Localized></MenuItem>
                </TextField>
                {serverError && (
                    <Alert
                        sx={{ mt: 2 }}
                        onClose={() => {
                            setServerError("");
                        }}
                        severity="error"
                    >
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>

            <DialogActions>
                <DialogActions>
                    <SaveButton loading={saving} onClick={handleOkClick} />
                    <CancelButton loading={saving} onClick={onCancel} />
                </DialogActions>
            </DialogActions>
        </Dialog>
    </>
}
